<template>
  <div
    class="dialog-background q-px-md q-pt-md semi-rounded bordered-steel-grey-4"
    :style="formDef ? 'width: 436px' : 'width: 430px'"
  >
    <div v-if="title" class="q-pb-md title-2">{{ title }}</div>
    <div v-if="message" class="q-pb-md" style="overflow-wrap: break-word">
      {{ message }}
    </div>
    <div v-if="formDef" class="q-pb-md">
      <form-field
        v-for="field of formDef"
        class="col-12 q-pb-md"
        :field-def="field"
        :values="values"
      ></form-field>
    </div>
    <div v-if="cancel || ok" class="q-pb-md text-right">
      <q-btn
        v-if="cancel"
        class="secondary-button semi-rounded"
        id="cancel-button"
        style="width: 119px; height: 40px"
        :label="cancelLabel"
        @click="onCancelClick"
      />
      <q-btn
        v-if="ok"
        :class="`semi-rounded q-ml-md text-white ${'bg-' + colorType}`"
        id="ok-button"
        style="width: 129px; height: 40px"
        :label="okLabel"
        @click="onOKClick"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import FormField from "src/components/FormField.vue";

const emit = defineEmits(["onCancelClick", "onOKClick"]);
const props = defineProps({
  typeColor: String,
  title: String,
  message: String,
  ok: {
    type: [String, Object, Boolean],
  },
  cancel: {
    type: [String, Object, Boolean],
  },
  values: {
    default: () => {
      return {};
    },
    type: Object,
  },
  formDef: Object,
  vision: Number,
});
const colorType = computed(() => {
  return props.ok.class ?? "primary";
});

const cancelLabel = computed(() => {
  if (typeof props.cancel === "boolean") return "Fechar";
  if (typeof props.cancel === "string") return props.cancel;
  if (typeof props.cancel === "object") return props.cancel.label;
});
const okLabel = computed(() => {
  if (typeof props.ok === "boolean") return "Ok";
  if (typeof props.ok === "string") return props.ok;
  if (typeof props.ok === "object") return props.ok.label;
});

const onCancelClick = () => {
  emit("onCancelClick");
};
const onOKClick = () => {
  emit("onOKClick");
};
</script>
